<template>
  <div v-frag>
    <v-card
      class="rounded-huge glass-card hover-lift menu-card d-flex flex-column align-center justify-center pa-4"
      @click="$emit('press')"
      height="180"
      width="100%"
    >
      <div 
        class="icon-box rounded-xl mb-4 d-flex align-center justify-center shadow-sm"
        :style="{ backgroundColor: color, boxShadow: '0 8px 16px -4px ' + color + '60' }"
      >
        <v-img
          :src="icon"
          width="32"
          height="32"
          contain
          class="white-icon"
        ></v-img>
      </div>

      <v-card-text class="text-center pa-0">
        <div class="text-caption font-weight-bold grey--text text--darken-3 text-uppercase letter-spacing-1 mb-1">
          {{ text }}
        </div>
        <v-chip
          v-if="newOption"
          x-small
          label
          color="error"
          class="rounded-pill font-weight-bold px-2"
          style="height: 18px; font-size: 0.65rem;"
        >
          NUEVO
        </v-chip>
      </v-card-text>
    </v-card>
  </div>
</template>

<style scoped>
.menu-card {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  cursor: pointer;
  border: 1px solid rgba(0, 0, 0, 0.05) !important;
}
.icon-box {
  width: 64px;
  height: 64px;
  transition: all 0.3s ease;
}
.white-icon {
  filter: brightness(0) invert(1);
}
.menu-card:hover .icon-box {
  transform: scale(1.1) rotate(5deg);
}
.letter-spacing-1 {
  letter-spacing: 0.5px !important;
}
</style>

<script>
export default {
  name: "CardIeaCategory",
  props: ["text", "icon", "color", "newOption"],
  data: () => ({}),
  methods: {}
};
</script>
